import { i18n } from '@percent/education-hosted-form/i18n/config'
import { Layout, ErrorCard } from '@percent/education-hosted-form/ui'

export function ErrorFallback() {
  const { t } = i18n

  return (
    <Layout>
      <ErrorCard
        title={t('errorMessage.somethingWentWrong')}
        subtitle={t('errorMessage.reloadPage')}
        variant={ErrorCard.variants.INTERNAL}
      />
    </Layout>
  )
}
